var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 10,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 10,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 10,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 10,
    stroke: "#EEEFF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.753 12.3666V17.3281H31.7144L26.753 12.3666Z",
    fill: "#2361FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0392 18.1702L19.5963 17.7272V22.6896H24.5586L20.0392 18.1702Z",
    fill: "#2361FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2452 17.3281H13.9149C13.3459 17.3281 12.8848 17.7892 12.8848 18.3583V31.9375C12.8848 32.5065 13.3459 32.9676 13.9149 32.9676H23.9277C24.4968 32.9676 24.9579 32.5065 24.9579 31.9375V24.04H18.2462L18.2452 17.3281Z",
    fill: "#2361FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4011 18.6794V11.9677H21.0699C20.5009 11.9677 20.0398 12.4287 20.0398 12.9978V16.2652L25.5107 21.7362L26.2861 22.5341V27.607H31.0818C31.6508 27.607 32.1119 27.1459 32.1119 26.5768L32.1128 18.6793L25.4011 18.6794Z",
    fill: "#2361FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.a7e19ace813aed6e4d760be0bbe0da6a.svg";
export { ForwardRef as ReactComponent };